<script lang="tsx">
import { defineComponent, type PropType } from 'vue'
import EnumSelect from '../../selects/enum-select'
import { EnumSelectFilter } from '../Filters'

export default defineComponent({
  props: {
    filter: {
      type: Object as PropType<EnumSelectFilter>,
      required: true,
    },
  },
  setup(props) {
    const setValue = (val: { id: string, name: string } | undefined) => {
      props.filter.addValue(val)
    }

    return () => (
      <div class="ark-ui-filterbar-enum-select-filter">
        <EnumSelect
          placeholder={props.filter.label}
          endpoint={props.filter.endpoint}
          modelValue={props.filter.value}
          onValueChange={setValue}
          itemConverter={props.filter.itemConverter}
          params={props.filter.params}
          searchKey={props.filter.searchKey}
          paramsSerialization={props.filter.paramsSerialization}
          additionalItems={props.filter.additionalItems}
          showItemsCount={5}
        />
      </div>
    )
  },
})
</script>

<style lang="scss" scoped>
</style>
